// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import {
  TriageItemCounts,
  triageItemCountsResponseSchema,
} from '@/items/api/triage-types';

/**
 * Fetches the count of triage items by status.
 *
 * @returns Promise containing the counts of items needing review and matched items
 */
export async function getTriageItemCounts(): Promise<TriageItemCounts> {
  const url = '/v1/item-triage/counts';
  const response = await api.get(url);
  const result = await parseResponse(
    triageItemCountsResponseSchema,
    response.data,
    {
      schemaName: 'TriageItemCounts',
      endpoint: url,
    }
  );
  return result.data;
}
